import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Rocket, Target, MessageSquare, MapPin, ChevronRight, Lightbulb } from 'lucide-react';

const ActivationSection = ({ toolkit }) => {
  const strategies = toolkit.activation.sourcingStrategies;
  const tips = toolkit.activation.conversationTips;
  const venues = toolkit.activation.idealVenues;
  
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
          <Rocket className="w-6 h-6 text-purple-700" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Activation Guide</h2>
          <p className="text-gray-600">How to source stories and run conversations</p>
        </div>
      </div>

      <Card className="border-2 border-green-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Target className="w-5 h-5 text-green-700" />
            Story Sourcing Strategies
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {strategies.map((strategy, idx) => (
            <div key={idx} className="flex items-start gap-3 p-3 bg-green-50 rounded-lg">
              <ChevronRight className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700 text-sm">{strategy}</span>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="border-2 border-blue-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-blue-700" />
            Conversation Tips
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {tips.map((tip, idx) => (
            <div key={idx} className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <Lightbulb className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700 text-sm">{tip}</span>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="border-2 border-amber-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-amber-700" />
            Ideal Story Collection Venues
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-3">
            {venues.map((venue, idx) => (
              <span key={idx} className="px-4 py-2 bg-amber-100 text-amber-800 rounded-full text-sm font-medium">
                {venue}
              </span>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ActivationSection;
